<template>
  <main class="wait-main">
    <!-- Background with coffee bean on the right (desktop) -->
    <div class="background-container background-desktop">
      <img 
        src="@/assets/img/KV_Fond_Dotation.jpg" 
        alt="Background" 
        class="background-image"
      />
    </div>
    
    <!-- Background with coffee bean centered (mobile) -->
    <div class="bean-section-mobile"></div>

    <!-- Main container - Two columns layout -->
    <div class="container">
      <div class="content-wrapper">
        <!-- Left column: Text content centered -->
        <div class="left-column">
          <div class="text-content">
            <h1 class="title">
              Le jeu n'a pas<br/>
              encore commencé !
            </h1>
            
            <p class="message">
              Rendez-vous le<br/>
              <span class="date-highlight">01 février 2026</span><br/>
              pour tenter votre chance
            </p>

            <p class="sub-message">
              En attendant, retrouvez toutes<br/>
              nos actualités sur le site Carte Noire
            </p>

            <a href="https://www.cartenoire.fr" target="_blank" class="site-link">
              www.cartenoire.fr
            </a>
          </div>
        </div>

        <!-- Right column: Space for coffee bean background -->
        <div class="right-column"></div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "WaitView",
};
</script>

<style scoped>
.wait-main {
  background-color: #000;
  color: white;
  position: relative;
  min-height: calc(100vh - 150px);
  display: flex;
  flex-direction: column;
}

/* Container */
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 60px;
  position: relative;
  z-index: 10;
  width: 100%;
  flex: 1;
}

/* Background - Coffee bean on the right */
.background-container {
  position: absolute;
  top: 0;
  left: 0%;
  bottom: 5%;
  width: 100%;
  pointer-events: none;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  transition: all 0.3s ease;
}

.background-desktop {
  display: flex;
}

.bean-section-mobile {
  display: none;
}

.background-image {
  width: auto;
  height: 110%;
  max-height: none;
  object-fit: cover;
  object-position: center;
  transition: all 0.3s ease;
}

/* Content wrapper */
.content-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: calc(100vh - 150px);
  align-items: center;
}

/* Left Column - Text centered */
.left-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
}

.text-content {
  text-align: center;
}

.title {
  font-family: var(--font-primary);
  font-size: 34px;
  font-weight: 900;
  line-height: 1.2;
  margin: 0 0 40px 0;
  color: white;
  text-transform: uppercase;
}

.message {
  font-family: var(--font-primary);
  font-weight: 500;
  font-size: 28px;
  color: white;
  line-height: 1.3;
  margin: 0 0 25px 0;
}

.date-highlight {
  font-weight: 900;
  font-size: 34px;
  display: inline-block;
  margin: 10px 0;
}

.sub-message {
  font-family: var(--font-primary);
  font-weight: 400;
  font-size: 18px;
  color: #ccc;
  line-height: 1.4;
  margin: 0 0 25px 0;
}

.site-link {
  font-family: var(--font-primary);
  font-weight: 700;
  font-size: 20px;
  color: white;
  text-decoration: underline;
  transition: opacity 0.3s ease;
}

.site-link:hover {
  opacity: 0.8;
}

/* Right Column - Empty for background */
.right-column {
  /* Space for coffee bean background */
}

/* Tablet breakpoint */
@media (max-width: 1024px) {
  .content-wrapper {
    grid-template-columns: 1.2fr 0.8fr;
  }

  .background-container {
    width: 50%;
  }
}

/* Mobile/Tablet transition */
@media (max-width: 768px) {
  .wait-main {
    min-height: auto;
  }

  .container {
    padding: 0 30px;
    order: 1;
  }

  .content-wrapper {
    grid-template-columns: 1fr;
    min-height: auto !important;
    height: auto;
  }

  .left-column {
    min-height: auto;
    height: auto;
    padding: 40px 0 0 0;
  }

  .background-desktop {
    display: none;
  }

  .bean-section-mobile {
    display: block;
    width: 100%;
    height: 350px;
    order: 2;
    background-image: url('@/assets/img/KV_Fond.jpg');
    background-size: 120% auto;
    background-position: center 70%;
    background-repeat: no-repeat;
    background-color: #000;
  }

  .right-column {
    display: none;
  }

  .title {
    font-size: clamp(24px, 6vw, 34px);
    margin-bottom: 25px;
  }

  .message {
    font-size: clamp(18px, 4vw, 24px);
  }

  .date-highlight {
    font-size: clamp(22px, 5vw, 30px);
  }

  .sub-message {
    font-size: clamp(14px, 3.5vw, 18px);
  }

  .site-link {
    font-size: clamp(16px, 4vw, 20px);
  }
}

/* Small mobile */
@media (max-width: 480px) {
  .bean-section-mobile {
    height: 300px;
    background-size: 140% auto;
  }
}
</style>
